<template>
	<div>
		<el-dialog title="新建手动上传任务" :visible.sync="confirmManualDialogShow" width="600px" :center="true" :close-on-click-modal="false" @close="clear">
			<el-form :model="manualConfigForm" ref="manualConfigForm" :rules="rules" label-position="left" label-suffix="：" label-width="120px">
				<el-form-item label="项目名称">
					{{manualConfigForm.title}}
				</el-form-item>
				<el-form-item label="任务名称" prop="data_set_name">
					<el-input v-model="manualConfigForm.data_set_name"></el-input>
				</el-form-item>
				<el-form-item label="上传路径" prop="oss_prefix">
					<el-input v-model="manualConfigForm.oss_prefix" type="textarea" :rows="2"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="manualProjectAction" size="mini" :disabled="isDisabled">确认</el-button>
				<el-button type="danger" @click="confirmManualDialogShow=false" size="mini">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="数据处理流程" :visible.sync="confirmConfigDialogShow" width="400px" :center="true" :close-on-click-modal="false">
			<el-form :rules="rules" label-position="left" label-suffix="：" label-width="100px">
				<el-form-item label="流程状态">
					<el-select v-model="workflow" placeholder="请选择数据处理流程" style="width:100%">
		    			<el-option
		      				v-for="item in workflows"
		      				:key="item.value"
		      				:label="item.label"
		      				:value="item.value">
		    			</el-option>
		  			</el-select>
		  		</el-form-item>
		  		<p>预计各节点所需时间：</p>
		  		<el-form-item v-for="(opt, $idx) in curOption" v-if="$idx !== curOption.length - 1" :key="opt.sequence" :label="opt.option.title">
		  			<el-input-number v-model="opt.need_days" style="width: 80%" :step="0.5" :min="0" :precision="1" @change="inputNumberChange($idx)"></el-input-number>&nbsp;&nbsp;天
		  		</el-form-item>
		  	</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="configProjectAction" size="mini" :disabled="isDisabled">确认</el-button>
				<el-button type="danger" @click="confirmConfigDialogShow=false" size="mini">取消</el-button>
			</span>
		</el-dialog>
		<div class="card" :style="{'background-color':item.state!==500 && item.state!==600?'#ffffff':'#f2f2f2','box-shadow':mouseover?'0px 0px 10px 2px #4A90E2':''}"
		 @click="projectDetail" @mouseover="mouseover=true" @mouseout="mouseover=false">
			<div class="card-top">
				<label class="title-ellipsis">{{getitemTitle(item.title)}}</label>
				<label class="card-top-state">{{COLLECT_STATE_MAP[item.state]}}</label>
			</div>
			<div class="card-item" style="margin-top:14px">
				<label class="card-item-title">{{'ID:'}}</label>
				<label class="card-item-value">{{getitemTitle(item.job_uid)}}</label>
			</div>
			<div class="card-item">
				<label class="card-item-title">{{'数据处理流程'}}</label>
			</div>
			<div class="card-item work-flow">
				<div class="work-flow-item"  v-for="(option,index) in item.options" :key="option.id">
					<template v-if="index !== item.options.length - 1">
						<el-button type="primary" plain size="mini" style="padding-left:5px;padding-right:5px">{{option.option.title}}</el-button>
						<i class="el-icon-arrow-right" style="color:#0081EC;padding-right: 3px;font-size: 12px;"></i>
					</template>
				</div>
				<el-button type="primary" plain size="mini" style="padding-left:5px;padding-right:5px" v-if="item.options.length">{{item.options[item.options.length - 1].option.title}}</el-button>
				<span v-if="item.options.length===0">暂无</span>
			</div>
			<div class="card-bottom">
				<div v-for="(operation,index) in operationButtons" :key="index" :style="{'width':(334 / operationButtons.length).toFixed(2)+'px', 'background-color':bottomMouseover[index].mouseover?'#19A3F9':'#f7faff'}">
					<div @mouseover="bottomMouseover[index].mouseover = true" @mouseout="bottomMouseover[index].mouseover = false"
					 style="display:flex;algin-items:center">
						<el-button @click.stop="projectOperation(operation)" size="mini" type="text"  class="card-bottom-button" :style="{'color':bottomMouseover[index].mouseover?'#ffffff':'#19A3F9'}">{{buttonTitle(operation)}}
						</el-button>
						<div v-if="index < operationButtons.length -1" class="card-bottom-vline" v-show="bottomMouseoverLineShow[index].lineShow"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.card {
        position: relative;
		cursor: pointer;
		background-color: #ffffff;
		border: 1px solid #c0ccda;
		text-align: left;
		float: left;
		width: 334px;
		height: 260px;
		margin-top: 0px;
		overflow: hidden;

		.card-top {
			margin-top: 31px;
			margin-left: 19px;
			margin-right: 19px;

			.card-top-state {
				font-size: 14px;
				margin-left: auto;
				margin-right: 0px;
				float: right;
				color: #000000;
			}

			.title-ellipsis {
				margin-left: 0px;
				font-size: 8px;
				font-size: 16px;
				color: #030303;
			}
		}

		.card-item {
			margin-left: 19px;
			margin-right: 10px;
			margin-top: 8px;
			height: 20px;

			.card-item-title {
				font-size: 14px;
				color: #030303;
			}

			.card-item-value {
				font-size: 14px;
				color: #3b3a3a;
			}

			.el-button.is-plain {
				padding-top: 3px;
				padding-bottom: 3px;
			}
		}

		.work-flow{
			min-height: 90px;
			overflow-y: scroll;
			.work-flow-item{
				display: inline-block;
				margin-bottom: 10px;
			}
			&::-webkit-scrollbar {
				width: 5px;
			}
			&::-webkit-scrollbar-thumb {
				width: 5px;
				background:#c0ccda;
				border-radius: 10px;
			}
			&::-webkit-scrollbar-button {
				display: none;
			}
		}

		.card-bottom {
			height: 44px;
			background-color: #f7faff;
			text-align: center;
			display: flex;
			border-top: #c0ccda solid 1px;
            position:absolute;
            bottom:0 ;
			.card-bottom-button {
				color: #1890ff;
				font-size: 14px;
				width: 100%;
				height: 44px;
			}

			.card-bottom-vline {
				height: 25px;
				width: 1px;
				background-color: #c0ccda;
				margin-top: 10px;
			}
		}
	}

</style>
<script>
	import ProjectOperationFlowUtils from "@/js/utils/projectOperationFlow";
	import config from "@/js/utils/config";
	import {
		MessageBox
	} from "element-ui";
	export default {
		name: "PMSProjectCard",
		props: {
			source: String,
			item: {}
		},
		computed: {
			curOption() {
				let options;
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						options =  JSON.parse(JSON.stringify(workflow.options));
					}
				});
				return options;
			}
		},
		data() {
			return {
				confirmConfigDialogShow: false,
				confirmManualDialogShow: false,
				bottomMouseover: [{
						mouseover: false,
					},
					{
						mouseover: false,
					}
				], //此处最多两个按钮，须优化成动态展示为操作按钮个数相同

				bottomMouseoverLineShow: [{
						lineShow: true,
					},
					{
						lineShow: true,
					}
				],
				mouseover: false,
				COLLECT_STATE: ProjectOperationFlowUtils.COLLECT_STATE,
				COLLECT_STATE_MAP: ProjectOperationFlowUtils.COLLECT_STATE_MAP,
				PROJECT_LIST_CARD_OPERATION: ProjectOperationFlowUtils.PROJECT_LIST_CARD_OPERATION,
				manualConfigForm: {
					create_type: 1,
					job_uid: '',
					title: '',
					region: '',
					data_set_name: undefined,
					oss_prefix: undefined
				},
				workflows: [],
				workflow: '',
				operationButtons: [],
				rules: {
					oss_prefix: [
						{required: true, message: '请填写上传路径'}
					],
					data_set_name: [
						{required: true, message: '请填写任务名称'}
					]
				},
				isDisabled:false
			};
		},
		created() {
			this.operationButtons = this.getOperationButtons();
		},

		watch: {

			bottomMouseover: {
				handler: function (newVal, oldVal) {
					for (let index = 0; index < this.bottomMouseover.length; index++) {
						const element = this.bottomMouseover[index];
						const lineShowElement = this.bottomMouseoverLineShow[index];
						if (element.mouseover) {
							//一次取相邻的两个变量（此处为后一个变量）将相邻的后面的竖线隐藏
							if (index > 0) {
								const nextElement = this.bottomMouseoverLineShow[index - 1];
								nextElement.lineShow = false;
							}
							if (this.operationButtons.length == 2) {
								lineShowElement.lineShow = false;
							} else {
								lineShowElement.lineShow = true;
							}
						} else {
							lineShowElement.lineShow = true;
						}

					}
				},
				deep: true
			},
		},
		methods: {
			inputNumberChange(idx) {
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						workflow.options[idx].need_days = this.curOption[idx].need_days;
					}
				});
			},

             initDataValue(){
                this.bottomMouseoverLineShow= [{
						lineShow: true,
					},
					{
						lineShow: true,
					}
				];

				this.bottomMouseover= [{
					mouseover: false
				}, {
					mouseover: false
				}];//此处最多两个按钮，须优化成动态展示为操作按钮个数相同
				this.mouseover=false;
            },

            getOptions() {
            	let url = config.api.options;
            	this.workflows = [];
				return this.HttpUtils.get(url, {}).then(result => {
					let options = result.data.options;
					options.forEach((opt, idx) => {
						this.workflows.push({
							value: idx,
							label: opt.reduce((prev, cur) => {prev.push(cur.option.title);return prev;}, []).join(","),
							// options: Object.assign(opt, {need_days: 0})
							options: opt.map(e => Object.assign(e, {need_days: 0}))
						});
					});

				}).catch(execption => {
					console.log(execption);
				});
            },

			getCollectTotalCount() {
				if (!this.item.total_count || parseInt(this.item.total_count) == 0) {
					return "暂无记录";
				}
				return this.item.total_count;
			},
			getitemTitle(title) {
				if (title.length > 20) {
					let newtitle = title.slice(0, 20) + "...";
					return newtitle;
				}
				return title;
			},
			projectDetail() {

				this.$emit("projectDetail", this.item.id, this.item.edit, this.item.job_uid);
			},
			buttonTitle(item) {
				return this.PROJECT_LIST_CARD_OPERATION[item];
			},

			getOperationButtons() {
				let operations = this.projectListCardOperation(this.item.procedure_state, this.item.state);
				return operations;
			},
			projectOperation(operation) {
                this.initDataValue();
				this.operation(operation, this.item.id, this.item.state);
			},

			operation(operation, projectID, projectState) {
				let userinfo = JSON.parse(localStorage.getItem("userinfo"));
				console.log("operation:" + operation);

				switch (operation) {
                    case "CONFIG":
                    	this.getOptions().then(() => {
                    		this.workflowActon = "create";
	                    	this.workflow = this.workflows[0].value;
	                    	this.confirmConfigDialogShow = true;
                    	});

						break;
					case "MODIFY":
						this.getOptions().then(() => {
							this.workflowActon = "update";
							for (let i=0; i<this.workflows.length; i++) {
								let matched = true;
								for (let j=0; j<this.item.options.length; j++) {
									if (!this.workflows[i].options[j] || this.item.options[j].option.id !== this.workflows[i].options[j].option.id) {
										matched = false;
									}
								}
								if (matched) {
									this.workflow = this.workflows[i].value;
									this.workflows[i].options = this.item.options;
								}
							}

							this.confirmConfigDialogShow = true;
						});

						break;
					case "MANUAL":
						Object.assign(this.manualConfigForm, this.item);
						this.confirmManualDialogShow = true;
						break;
					default:
						break;
				}
			},

			projectListCardOperation(projectStatus, state) {
				var buttons = [];
				switch (projectStatus) {
                     case 0:// 未配置
                        buttons = ["CONFIG"];
						break;
					case 1:// 配置
						buttons = ["MODIFY", "MANUAL"];
						break;
					default:
						break;
				}
				if (state === this.COLLECT_STATE.FINISH || state === this.COLLECT_STATE.TURN_OFF) {
					buttons = [];
				}
				return buttons;
			},
			configProjectAction() {
				let url = config.api.job_procedure;
				let options;
				this.workflows.forEach(workflow => {
					if (this.workflow === workflow.value) {
						options = workflow.options;
					}
				});
				// 预计各节点所需时间校验
				// let hasError = false;
				// options.forEach((opt, idx) => {
				// 	if (idx !== options.length - 1 && (window.isNaN(+this.curOption[idx].need_days) || +this.curOption[idx].need_days <= 0)) {
				// 		hasError = true;
				// 		this.$alert(opt.option.title + '所需天数填写错误' ,'提示');
				// 		return;
				// 	}
				// });
				// if(hasError) return;

				this.isDisabled = true
				if (this.workflowActon === "create") {
					this.HttpUtils.post(url, {
						"job_uid": this.item.job_uid,
					    "options": options.map((opt,idx) => ({"sequence": opt.sequence, option_id: opt.option.id, need_days: this.curOption[idx].need_days}))
					}).then(result => {
						document.location.reload();
					}).catch(execption => {
						console.log(execption);
					}).finally(() =>{
						this.isDisabled = false;
					});
				} else {
					this.HttpUtils.patch(url + '/' + this.item.job_uid, {
					    "options": options.map((opt,idx) => ({"sequence": opt.sequence, option_id: opt.option.id, need_days: this.curOption[idx].need_days}))
					}).then(result => {
						document.location.reload();
					}).catch(execption => {
						console.log(execption);
					}).finally(() =>{
						this.isDisabled = false;
					});
				}
			},
			manualProjectAction() {
				this.isDisabled = true
				this.$refs.manualConfigForm.validate(valid => {
					if (valid) {
						let url = config.api.data_sets;
						this.HttpUtils.post(url, this.manualConfigForm).then(result => {
							this.confirmManualDialogShow = false;
							document.location.reload();
						}).catch(execption => {
							console.log(execption);
						}).finally(() => {
							this.isDisabled = false;
						});
					}
				});
			},
			clear() {
				this.manualConfigForm.job_uid = '';
				this.manualConfigForm.oss_prefix = '';
				this.manualConfigForm.data_set_name = '';
				this.manualConfigForm.title = '';
				this.$refs.manualConfigForm && this.$refs.manualConfigForm.resetFields();
			}
		}
	};

</script>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_list/PMSProjectCard.vue